// extracted by mini-css-extract-plugin
module.exports = {"container":"notReceiving_container__1alPf","kiwi":"notReceiving_kiwi__gKdIP","textContainer":"notReceiving_textContainer__33djt","text":"notReceiving_text__cuBSF"};